import { DatePipe, NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-hl-footer',
  templateUrl: './hl-footer.component.html',
  styleUrls: ['./hl-footer.component.scss'],
  imports: [DatePipe, NgOptimizedImage],
})
export class HlFooterComponent {
  public today: Date = new Date();
}
